import { TweenMax } from 'gsap';
import { Rectangle } from 'pixi.js';
import { getGameSize } from '../../../Config/Levels';
import Core from '../../../Core/Core';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { ISDKLeaderboardPlayer } from '../../../SDK/SDKleaderboards';
import { createOutlineText } from '../../../Utils/Utils';
import { AskFrButton } from '../../Shared/Buttons/AskFrButton';
import { UIButton } from '../../Shared/Buttons/UIButton';
import { ScrollView } from '../../Shared/ScrollView/ScrollView';
import { ITweenable } from '../ITweenable';
import { LevelLeaderboardItem } from './LevelLeaderboardItem';
import Point = PIXI.Point;

export class LevelLeaderboard extends PIXI.Container implements ITweenable {
    public readonly usableHeight: number;

    private scrollView: ScrollView;
    private inviteFriends: PIXI.Container;
    private playerPosition: Point;

    constructor(width: number) {
        super();
        const bg = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/lowerhud-bg']);
        bg.scale.set(width / bg.width, 1.5);

        this.addChild(bg);
        this.scrollView = new ScrollView(bg.width, bg.height, this);

        this.usableHeight = this.height;

        const inviteFriends = (this.inviteFriends = new PIXI.Container());
        const inviteText = createOutlineText(
            `${Core.local.getText('nofriends').split('!')[0]}!`,
            new Rectangle(0, 0, bg.width, this.usableHeight / 1.9),
            'Baloo',
            28,
            30
        );
        const inviteButton = new AskFrButton(
            bg.width / 2,
            this.usableHeight / 3,
            Core.local.getText('invite')
        );
        inviteButton.on(UIButton.events.Trigger, () =>
            HudEmitter.instance.emit(HudActions.INVITE_PLAYER)
        );
        //@ts-ignore
        inviteFriends.addChild(inviteText, inviteButton);
        inviteFriends.x = bg.width / 2;
        inviteFriends.y = inviteFriends.height / 1.5 + this.usableHeight / 2;
        inviteText.y = -inviteFriends.height / 2 - inviteText.height / 2;
        this.addChild(inviteFriends);
    }

    public setData(data: ISDKLeaderboardPlayer[], timed: boolean) {
        if (data.length > 0 && this.inviteFriends.parent) {
            this.removeChild(this.inviteFriends);
        } else {
            this.addChild(this.inviteFriends);
        }
        // const container = new PIXI.Container();
        for (let i = 0; i < data.length; i++) {
            const leaderboardItem = new LevelLeaderboardItem(data[i], i + 1, timed);
            leaderboardItem.x = leaderboardItem.width / 2 + i * leaderboardItem.width;
            leaderboardItem.y = this.usableHeight * 0.2;
            if (data[i].user.isCurrentUser) {
                this.playerPosition = new Point(
                    leaderboardItem.position.x,
                    leaderboardItem.position.y
                );
            }
            this.scrollView.addItem(leaderboardItem);
        }
        this.tweenIn();
        this.centerOnPlayer();
    }

    public tweenIn(): void {
        const { gameHeight } = getGameSize();
        TweenMax.to(this, 0.3, {
            y: gameHeight - this.usableHeight,
        });
    }

    public tweenOut(): void {
        const { gameHeight } = getGameSize();
        TweenMax.to(this, 0.2, {
            y: gameHeight,
            onComplete: () => {
                this.destroy();
            },
        });
    }

    private centerOnPlayer() {
        if (!this.playerPosition) {
            return;
        }
        const { x, y } = this.playerPosition;
        this.scrollView.scrollView.snap(x, y, {
            time: 500,
            removeOnComplete: true,
            interrupt: true,
        });
    }
}
